
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36 30"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"currentColor"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M6 6.993C6 5.893 6.896 5 7.993 5h15.67c1.1 0 1.992.898 1.992 1.993v14.635c0 1.1-.895 1.993-1.993 1.993H7.992c-1.1 0-1.992-.898-1.992-1.993V6.993zM26.69 12.5l7.58-4.422c.956-.557 1.73-.108 1.73.988v11.523c0 1.103-.778 1.544-1.73.988l-7.58-4.422V12.5z"}}),_c('path',{attrs:{"d":"M0 29L30 1"}})])])
      }
    
      }
    